<template>
  <advanced-card
    :init-collapsed="false"
    title="Autoclose"
    tooltip="Ad will automatically close itself after a specific time."
  >
    <div class="list-item">
      <div class="form-group">
        <div class="toggle-wrapper end">
          <toggle
            id="adtag-autoclose-enabled"
            label="Enable autoclose feature"
            :value="enabled"
            @input="updateAutoCloseFeature($event, 'enabled')"
          />
        </div>
      </div>
      <div v-if="enabled">
        <label class="input-label">timeout</label>
        <div class="form-group">
          <text-input
            id="adtag-autoclose-timeout"
            :is-draggable="true"
            :max-width="222"
            :min-width="222"
            name="autocloseDuration"
            suffix="ms"
            type="text"
            :value="duration"
            @change="updateAutoCloseFeature($event, 'duration')"
          />
        </div>
      </div>
      <div v-if="enabled">
        <div class="form-group">
          <div class="toggle-wrapper end">
            <toggle
              id="adtag-autoclose-interaction"
              label="Cancel timeout by user interaction"
              name="autocloseCancel"
              type="text"
              :value="cancelOnInteraction"
              @input="updateAutoCloseFeature($event, 'cancelOnInteraction')"
            />
          </div>
        </div>
      </div>
    </div>
  </advanced-card>
</template>

<script>
import TextInput from "@/components/common/form/TextInput.vue"
import AdvancedCard from "@/components/base/AdvancedCard.vue"

export default {
  name: "Autoclose",
  components: {
    AdvancedCard,
    TextInput
  },
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    duration: {
      type: [Number, String],
      default: "10000"
    },
    cancelOnInteraction: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update"],
  methods: {
    updateAutoCloseFeature (value, key) {
      const updatedValues = { ...this.$props, name: "autoclose" }
      updatedValues[key] = value
      this.$emit("update", updatedValues)
    }
  }
}
</script>
<style scoped>
#adtag-autoclose-interaction {
  height: auto;
}
</style>
